import { TokenRefresh } from "../../../model/signup/TokenRefresh";

export const waitForTokenRefresh = async (request: Request): Promise<void> => {
  await TokenRefresh.waitForRefreshedAccessToken(request);
};
